import { COMPANY_EDIT, COMPANY_VIEW } from "./types";

export const companyView = (data, onSuccess, onError) => {
    return {
        type: COMPANY_VIEW,
        data,
        onSuccess,
        onError,
    };
};

export const companyEdit = (data, onSuccess, onError) => {
    return {
        type: COMPANY_EDIT,
        data,
        onSuccess,
        onError,
    };
};

